(function () {
  var root = document.documentElement;
  var KEY = 'venerte-a11y';
  var FONT = ['', 'va-font-1', 'va-font-2', 'va-font-3'];
  var TOGGLES = ['va-contrast','va-invert','va-grayscale','va-light','va-links','va-readable','va-cursor','va-no-anim'];
  var state = {};
  try { state = JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { state = {}; }

  function save() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }

  function applyClasses() {
    TOGGLES.forEach(function (c) { root.classList.toggle(c, !!state[c]); });
    FONT.forEach(function (c) { if (c) root.classList.remove(c); });
    var lvl = state.font || 0;
    if (lvl > 0) root.classList.add(FONT[lvl]);
  }

  function reflectButtons() {
    document.querySelectorAll('[data-va]').forEach(function (b) {
      var k = b.getAttribute('data-va');
      if (k === 'font') b.setAttribute('aria-pressed', (state.font || 0) > 0 ? 'true' : 'false');
      else if (k === 'font-down' || k === 'reset') { /* actions, no state */ }
      else b.setAttribute('aria-pressed', !!state[k] ? 'true' : 'false');
    });
  }

  function init() {
    var toggle = document.querySelector('.va-toggle');
    var panel = document.querySelector('.va-panel');
    if (!toggle || !panel) return;
    var closeBtn = panel.querySelector('.va-panel__close');

    function open() {
      panel.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      var first = panel.querySelector('button, a');
      if (first) first.focus();
    }
    function close() {
      panel.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function () {
      panel.classList.contains('is-open') ? close() : open();
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('click', function (e) {
      if (panel.classList.contains('is-open') && !panel.contains(e.target) && !toggle.contains(e.target)) close();
    });

    panel.querySelectorAll('[data-va]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-va');
        if (k === 'font') state.font = ((state.font || 0) + 1) % 4;
        else if (k === 'font-down') state.font = ((state.font || 0) + 3) % 4;
        else if (k === 'reset') { state = {}; try { localStorage.removeItem(KEY); } catch (e) {} applyClasses(); reflectButtons(); return; }
        else state[k] = !state[k];
        save(); applyClasses(); reflectButtons();
      });
    });

    reflectButtons();
  }

  applyClasses(); // apply persisted prefs ASAP
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
